import { store } from '@wajeez-web/stores/base';
import { handleDispatchResult } from '@wajeez-web/core/utils';
import { Server } from '@wajeez-web/core/api-base';

import {
  getAuthorByIdMultilingualAsync,
  createAuthorMultilingualAsync,
  editAuthorMultilingualAsync,
} from './slices';

export const getAuthorByIdMultilingual = async (
  id: number,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getAuthorByIdMultilingualAsync(id));

  return handleDispatchResult(res, onSuccess);
};

export const createAuthorMultilingual = async (
  data: Server.CreateAuthorV2Input,
  onSuccess?: (authorId?: number) => void | Promise<void>
) => {
  const res = await store.dispatch(createAuthorMultilingualAsync(data));

  return handleDispatchResult(res, onSuccess);
};

export const editAuthorMultilingual = async (
  data: Server.EditAuthorV2Input,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(editAuthorMultilingualAsync(data));

  return handleDispatchResult(res, onSuccess);
};
